import { StyledDataWrapper } from '../../../molecules/UserPanel/StyledDataWrapper';
import { StyledText } from '../../../atoms/Text/StyledText';

const BudgetInfo = ({ budget }) => {
    return (
        <StyledDataWrapper>
            <StyledText
                hasdeclaredfontsize="20px"
                hasdeclaredfontweight="600"
                hasdeclaredfontcolor="#4E6BAA"
            >
                BUDŻET:
            </StyledText>

            <StyledText
                hasdeclaredfontsize="20px"
                hasdeclaredfontweight="600"
                hasdeclaredfontcolor={'#6AB95D'}
                hasdeclaredpadding="0 0 0 8px"
            >
                {budget.overallBudget} ({budget.budgetWithoutDues}) PLN
            </StyledText>
        </StyledDataWrapper>
    );
};

export default BudgetInfo;
